var formatRegExp = /\{(\d+)}/g;

export default function formatString(format) {
    var values = arguments;

    return format.replace(formatRegExp, function (match, index) {
        var value = values[parseInt(index, 10) + 1];

        return value;
    });
}
//# sourceMappingURL=format-string.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/common/format-string.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/format-string.js
// module chunks = 3